import React, { useMemo } from 'react';
import { addDays, isWeekend, xDias, anchoDias } from './constants';
import { useEscalasPorCapa, enRango, agruparCapas, OPACIDAD_CAPA } from './GanttHeader';

// En Día la unidad de abajo es el día: las líneas diarias saturan, así que
// se marcan los meses (fila de arriba). En el resto, la unidad de abajo. Dos
// escalas con las mismas líneas (Día y Mes marcan meses) las pintan una vez.
const lineasDe = (zoom, escala) => (zoom === 'dia'
  ? { tipo: 'meses', unidades: escala.arriba }
  : { tipo: escala.tipoAbajo === 'mes' ? 'meses' : escala.tipoAbajo, unidades: escala.abajo });

const conFinesDeSemana = (zoom) => zoom === 'dia' || zoom === 'semana';

/**
 * Fondo del cuerpo del Gantt: fines de semana sombreados (solo en Día y
 * Semana, donde un día mide lo suficiente para verse) y líneas verticales en
 * los límites de la unidad del encabezado de abajo, para leer fechas sin
 * subir la vista al encabezado.
 *
 * Igual que el encabezado: se ubica con --dw y acepta `capas` (las dos escalas
 * del viaje de la camara) y `rango` (lo que la camara llega a mostrar).
 */
const GanttGrid = ({ firstDay, totalDays, zoom, capas, rango }) => {
  const lista = capas || [{ zoom, rol: 'fija' }];
  const escalas = useEscalasPorCapa(lista, firstDay, totalDays);
  const visible = enRango(rango);

  const finde = agruparCapas(lista, (c) => (conFinesDeSemana(c.zoom) ? { tipo: 'finde', unidades: null } : null))[0];
  const firstMs = firstDay.getTime();

  const finesDeSemana = useMemo(() => {
    if (!finde) return [];
    const inicio = new Date(firstMs);
    const out = [];
    for (let i = 0; i < totalDays; i += 1) {
      if (isWeekend(addDays(inicio, i))) out.push(i);
    }
    return out;
  }, [finde, firstMs, totalDays]);

  const lineas = agruparCapas(lista, (c) => (escalas[c.zoom] ? lineasDe(c.zoom, escalas[c.zoom]) : null));

  return (
    <div className="absolute inset-0 pointer-events-none">
      {finde && (
        <div className="absolute inset-0" style={{ opacity: OPACIDAD_CAPA[finde.rol] }}>
          {finesDeSemana
            .filter((i) => !rango || (i + 1 >= rango.desde && i <= rango.hasta))
            .map((i) => (
              <div
                key={`we-${i}`}
                className="absolute top-0 bottom-0 bg-slate-100/50"
                style={{ left: xDias(i), width: anchoDias(1) }}
              />
            ))}
        </div>
      )}
      {lineas.map((f) => (
        <div key={f.tipo} className="absolute inset-0" style={{ opacity: OPACIDAD_CAPA[f.rol] }}>
          {f.unidades.filter(visible).map((u) => (
            <div
              key={`ln-${u.key}`}
              className="absolute top-0 bottom-0 w-px bg-slate-200/70"
              style={{ left: xDias(u.offset) }}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default GanttGrid;
